export default function useMultiAccountModal() {
  const multiAccountModal = ref(false)

  function showModal() {
    multiAccountModal.value = true
  }

  function closeModal() {
    multiAccountModal.value = false
  }

  return {
    multiAccountModal,
    showModal,
    closeModal,
  }
}
